import React from 'react'
import styles from './styles.module.scss'
import classNames from 'classnames'

type HeroProps = {
  title: string
  parentTitle?: string
  byline?: string
  parentTitleVisible?: boolean
}

const Hero = ({
  title,
  parentTitle,
  byline,
  parentTitleVisible
}: HeroProps) => {
  const isParentTitleVisible = parentTitle && parentTitle !== title

  const parentTitleClassNames = classNames(styles.hero__parentTitle, {
    [styles.visible]: isParentTitleVisible
  })

  return (
    <div className={styles.hero}>
      <div className={styles.hero__headings}>
        <h1 className={styles.hero__title}>
          {parentTitleVisible && (
            <span className={parentTitleClassNames}>{parentTitle}</span>
          )}
          {title}
          {!parentTitleVisible ? ' Collection' : ''}
        </h1>
        {byline && <h2 className={styles.hero__byline}>{byline}</h2>}
      </div>
    </div>
  )
}

export default Hero
